import { c as _c } from "react/compiler-runtime";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityHeaderCIC from "./UserPageIdentityHeaderCIC";
export default function UserPageIdentityHeader(t0) {
  const $ = _c(7);
  const {
    profile,
    cicOverview,
    onRateClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mb-6"><h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100">Network Identity Check (NIC)</h2><p className="tw-mb-0 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500">Does the network believe this profile accurately represents its identity?</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onRateClick) {
    t2 = onRateClick ? {
      onRateClick
    } : {};
    $[1] = onRateClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cicOverview || $[4] !== profile || $[5] !== t2) {
    t3 = <div className="tw-px-6 tw-pt-6">{t1}<UserPageIdentityHeaderCIC profile={profile} cicOverview={cicOverview} {...t2} /></div>;
    $[3] = cicOverview;
    $[4] = profile;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}